import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalenderRemove: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCalenderRemove"><Path d="M9 2H7V4H3V21H12V19H5V10H19V12H21V4H17V2H15V4H9V2Z" fill="currentColor"/><Path d="M16.0001 14.5858L14.5859 16.0001L16.5861 18L14.5859 19.9999L16.0001 21.4142L18.0003 19.4142L20.0001 21.4142L21.4144 20.0001L19.4145 18L21.4144 15.9999L20.0001 14.5858L18.0003 16.5858L16.0001 14.5858Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalenderRemove;
